define(['text!./templates/basler-show-contact.html'],
    templateStr => ['BaslerCommonService',
        function (BaslerCommonService) {
            return {
                restrict: 'A',
                scope: {
                    contact: '=',
                    hasVariousDrivers: '=',
                    readonly: '=',
                },
                require: '^baslerCollapsableSection',
                template: templateStr,
                link: function (scope) {
                    scope.getCollapsed = function () {
                            return scope.$parent.$parent.collapsed; //Angular Standard way is not nicely readable therefore this solution
                    };
                },
                controller: ['$scope', function ($scope) {
                    $scope.formatDate = formatDate;

                    function formatDate(isoString) {
                        return BaslerCommonService.formatDate(isoString);
                    }
                    $scope.hasValue = function (value) {
                      return value !== undefined;
                    };
                }],
            };
        },
    ]
);



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/baslercommon/directives/BaslerShowContact.js